import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'

function Values() {
  return (
    <>
      <Navbar />
        <div>Values</div>
      <Footer />
    </>

  )
}

export default Values